import InputFormField from "@/components/core/inputs/InputFormField";
import { Billing } from "@/type/core/offices/offices.types";
import { formHorizontalLayout, formValidateTriggers } from "@utils/Constant";

import { Form } from "antd";
import { FormInstance } from "antd/lib";
import { FunctionComponent } from "react";
import { useTranslation } from "react-i18next";

interface BillingFormProps {
  className?: string;
  billingForm: FormInstance;
  onBillingFormSubmit: (values: Billing) => void;
  onFieldsChange: () => void;
}

const BillingForm: FunctionComponent<BillingFormProps> = ({
  className,
  billingForm,
  onBillingFormSubmit,
  onFieldsChange,
}) => {
  const { t } = useTranslation();
  return (
    <Form
      form={billingForm}
      {...formValidateTriggers}
      {...formHorizontalLayout}
      className={`pt-16 ${className}`}
      onFinish={onBillingFormSubmit}
      onFieldsChange={onFieldsChange}
    >
      <InputFormField
        showLabel
        module="offices.office"
        field="officeName"
        required
        data-test={"input-label"}
        data-alt={t("offices.office.fields.officeName.label")}
      />
      <InputFormField
        showLabel
        module="offices.office"
        field="address1"
        required
        data-test={"input-label"}
        data-alt={t("offices.office.fields.address1.label")}
      />
      <InputFormField
        showLabel
        module="offices.office"
        field="address2"
        data-test={"input-label"}
        data-alt={t("offices.office.fields.address2.label")}
      />
      <InputFormField
        showLabel
        module="offices.office"
        field="zipCode"
        required
        data-test={"input-label"}
        data-alt={t("offices.office.fields.zipCode.label")}
      />
      <InputFormField
        showLabel
        module="offices.office"
        field="city"
        required
        data-test={"input-label"}
        data-alt={t("offices.office.fields.city.label")}
      />
    </Form>
  );
};

export default BillingForm;
